import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTabPanelModule } from 'devextreme-angular';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { FusService } from '../../../services/formulacion/fus.service';
import { TareaService } from '../../../services/formulacion/tarea.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
import { switchMap } from 'rxjs/operators';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-traspaso-de',
  templateUrl: './traspaso-de.component.html',
  styleUrls: ['./traspaso-de.component.css'],
  providers: [GeneralService, OperacionService, FusService, TareaService, TraspasoService]
})
export class TraspasoDeComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  totalPartidas: number;
  organismo: string;
  fuente: string;
  detalle: any = {};
  ttId: number;
  popupVisibleP: boolean = false;
  scrollByContent = true;
  scrollByThumb = true;
  poaTecho: any;
  dataResource: any[];
  dataIntervenciones: any[];
  dataOperaciones: any[];
  dataTareas: any[];
  dataFuentes: any[];
  dataPartidas: any[];
  dataPartidasA: any[];
  dataFuenteMeses: any[];
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEdt: boolean = false;
  popupVisibleSnd: boolean = false;
  popupVisibleChk: boolean = false;
  popupVisibleO: boolean = false;
  clicked: boolean = false;
  state_toogle: boolean = false;
  swFuentes: boolean = false;
  rol: number = 0;
  model: any = {
    'id': 0,
    'techo_id': '',
    'nro_traspaso': 0,
    'created_at': '',
    'intervencion_id': '',
    'operacion_id': '',
    'tarea_id': '',
    'justificacion': '',
    'estado_id': 1,
    'fuentes': [],
    'tipo_traspaso_id': ''
  }
  model2: any = {
    id: 0,
    techo_id: 0,
    nro_traspaso: 0,
    justificacion: '',
    estado_id: 1,
    tipo_traspaso_id: '',
    adicionaPartida: 0,
    partidas: []
  }
  estado_id: number;
  vigencia: any[];
  baseUrl: string;
  title_modal: string;
  titulo: string;
  partida_id: string;
  monto_total_liberado: number;
  monto_total_procesado: number;
  monto_total_partida: number;
  monto_total_ingresado: number;
  estado_traspaso: number;
  oTraspasos: any[];
  tabs = [{ id: 1, title: 'SELECCIÓN DE PARTIDAS' }, { id: 2, title: 'ENVÍO DE DATOS' }];
  tipoTraspaso: any = [{ id: 4, descripcion: 'Traspaso presupuestario' }, { id: 6, descripcion: 'Modificación física' }];
  total: number = 0;
  siTab = 0;
  dTarea: string = '';
  hasError: any;
  dateActual: Date = new Date();
  gestionSesionU: number = 0;
  adicionaPartida: number = 0;
  constructor(private route: ActivatedRoute, private _ts: TareaService, private _os: OperacionService, private _fs: FusService, private _gs: GeneralService, private _trs: TraspasoService) {
    this.estado_id = 20;
    this.ttId = 1;
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.model.intervencion_id = params.get('id'))).subscribe();
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.model.tipo_traspaso_id = params.get('tipo'))).subscribe();
    this.totalPartidas = 0;
    this.title_modal = '';
    this.monto_total_liberado = 0;
    this.monto_total_procesado = 0;
    this.monto_total_partida = 0;
    this.monto_total_ingresado = 0;
    this.estado_traspaso = 0;
    this.baseUrl = environment.apiEndpoint;
    this.poaTecho = {
      'descripcion_techo': '',
      'techo_unidad_organizacional': '',
      'techo_categoria_programatica': '',
      'techo_tipo_gasto': '',
      'techo_tipo_intervencion': '',
      'techo_gestion': ''
    };
    this.getPoaTecho(this.model.intervencion_id);
    this.clearErrors();
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];

    this.getOperacionesByAEId(this.model.intervencion_id);
    this.fuente = 'VACIO';
    this.organismo = 'VACIO';
    this.gestionSesionU = JSON.parse(localStorage.getItem('g'));
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;

    if (this.model.tipo_traspaso_id == 6)
      this.titulo = 'Modificación Física';
    else
      this.titulo = 'Traspaso Presupuestario';
    this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { intervencion_id: false, operacion_id: false, tarea_id: false, justificacion: false, partida: false, tipo_traspaso_id: false };
  }

  showModalPartidas(id: number) {
    this.getPartidasTraspasoById(id, this.ttId == 1 ? 'O' : 'D');
    this.popupVisibleP = true;
  }

  roundDown(number: number, decimals: number) {
    decimals = decimals || 0;
    return (Math.floor(number * Math.pow(10, decimals)) / Math.pow(10, decimals));
  }

  getPartidasTraspasoById(id: number, tipo: string) {
    this._trs.getPartidasTraspasoById(id, tipo).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataPartidasA = result.data;
          this.dataPartidasA.forEach(function (item) {
            if (item.precio_unitario_t == 0)
              item.precio_unitario_t = item.precio_unitario;

            if (item.precio_unitario_f == 0)
              item.precio_unitario_f = item.precio_unitario;

            var aux = item.monto / item.precio_unitario_t;
            if (item.cantidad_t == 0)
              item.cantidad_t = (Math.floor(aux * Math.pow(10, 2)) / Math.pow(10, 2));
            if (parseFloat(item.saldo) > 0) {
              var auxF = item.saldo / item.precio_unitario_f;
              if (item.cantidad_f == 0)
                item.cantidad_f = (Math.floor(auxF * Math.pow(10, 2)) / Math.pow(10, 2));
            }
            else {
              item.cantidad_f = 0;
              item.precio_unitario_f = 0;
            }

          });
        }
        else { this.dataPartidasA = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getTraspasos(id: string, tipo_id: string) {
    this._trs.getTraspasos(id, tipo_id).subscribe((response) => {
      let result = UtilHelper.responses(response);
      if (result.status == 200) {        
        this.dataResource = result.data;
      } else {
        this.dataResource = [];
      }
    },
      (error) => { console.log('Error', error); });
  }

  getPoaTecho(intervencion_id: string) {
    this._gs.getPoaTechoById(intervencion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.poaTecho = result.data;
        } else {
          this.poaTecho = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesByAEId(intervencion_id: string) {

    this.dataFuentes = [];
    this.dataTareas = [];
    this._os.getListOperacionesByIntId(intervencion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataOperaciones = result.data;
          
        } else {
          this.dataOperaciones = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getTareasByOperacionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this.dataFuentes = [];
      this._ts.getListTareasByOperacionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataTareas = result.data;
            
          } else {
            this.dataTareas = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getFuentesByTareaId(e: any, flag: number) {

    if (flag == 0) {
      if (e.value != undefined && e.value != null && e.value != '') {
        this._fs.getPatidasByTareaId(e.value).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.dataFuentes = result.data;
              
              if (this.dataFuentes.length == 0) {
                this.swFuentes = true;
              } else {
                this.swFuentes = false;
              }
            } else {
              this.dataFuentes = [];
            }
          },
          (error) => { console.log('Error', error); });
      }
    } else {
      this._fs.getPatidasByTareaId(e).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataFuentes = result.data;
          } else {
            this.dataFuentes = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalAdd() {
    if (this.model.tipo_traspaso_id == 6)
      this.title_modal = 'NUEVA MODIFICACIÓN FÍSICA';
    else
      this.title_modal = 'NUEVO TRASPASO PRESUPUESTARIO';
    this.siTab = 0;
    this.clearErrors();
    this.model.id = 0;
    this.model.operacion_id = '';
    this.model.tarea_id = '';
    this.model.justificacion = '';
    this.model.estado_id = 1;
    this.model.fuentes = [];
    //this.model.tipo_traspaso_id = '';
    this.model2.partidas = [];
    this.state_toogle = false;
    this.swFuentes = false;
    this.dataFuentes = [];
    if (this.gestionSesionU == this.dateActual.getFullYear()) {
      this.popupVisibleAdd = true;
    } else if (this.rol == 23) {
      this.popupVisibleAdd = true;
    }
    else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el Traspaso');
    }
  }

  showModalEdit(id: any) {

    if (this.gestionSesionU == this.dateActual.getFullYear()) {
      this.siTab = 1;
      this.dataFuentes = [];
      this.getTraspasoById2(id);
      this.clearErrors();
      this.state_toogle = true;
      this.popupVisibleAdd = true;
    }
    else {
      toastr.warning('Debe cambiar a la Gestión ' + this.dateActual.getFullYear() + ' para poder solicitar el Traspaso');
    }
  }

  getTraspasoById2(id: number) {
    this._trs.getTraspasoOrigenById2(id).subscribe(
      response => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.model2 = r.data;
          this.model.id = r.data.id;
          this.model.justificacion = r.data.justificacion;
          this.model.tipo_traspaso_id = r.data.tipo_traspaso_id;
          this.swFuentes = false;
          if (this.model.tipo_traspaso_id == 6)
            this.title_modal = 'NUEVA MODIFICACIÓN FÍSICA';
          else
            this.title_modal = 'NUEVO TRASPASO PRESUPUESTARIO';
        }
        else {
          this.swFuentes = true;
          this.dataFuentes = [];
        }
      },
      error => { console.log('Error', error); });
  }

  saveTraspaso() {
    this.clearErrors();
    this.model2.justificacion = this.model.justificacion;
    this.model2.tipo_traspaso_id = this.model.tipo_traspaso_id;
    
    if (this.model.id == 0) {
      this.model.fuentes = this.dataFuentes;
      this.model2.techo_id = this.model.intervencion_id;
      if (this.validate(this.model)) {
        this.clicked = true;
        this._trs.postTraspasoOrigen2(this.model2).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
              this.model2 = { id: 0, techo_id: 0, nro_traspaso: 0, justificacion: '', estado_id: 1, partidas: [] }
              this.fuente = 'VACIO';
              this.organismo = 'VACIO';
              this.clicked = false;
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados exitosamente.');
            } else {              
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    } else {
      if (UtilHelper.validator(this.model2.justificacion, 'text')) {
        this.model2.adicionaPartida = this.adicionaPartida;
        this._trs.putTraspasoOrigen2(this.model2).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
              this.popupVisibleAdd = false;
              toastr.success('Datos actualizados exitosamente.');
            }
            if (result.status == 201) {
              toastr.warning(response.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this.hasError.justificacion = true;
        toastr.warning('El traspaso debe tener una justificación.');
      }
    }
  }

  /**
   * metodo para mostrar la interfaz de Reprogramación
   * @param id 
   * @param pjustificacion 
   * @param ptotal 
   */
  showModalPrepare(id: number, pjustificacion: string, ptotal: number) {
    let self = this;
    this.popupVisibleEdt = true;
    this.dTarea = '';
    this.model.justificacion = pjustificacion;
    this.partida_id = '';
    this.monto_total_liberado = ptotal;
    this.monto_total_partida = 0;
    this.monto_total_procesado = 0
    this.dataFuenteMeses = [];
    this._trs.getPartidasTraspasoOById(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataPartidas = result.data;
          this.dataPartidas.forEach(function (item) {
            self.monto_total_procesado += (parseFloat(item.monto_procesado));
          });

        } else {
          this.dataPartidas = [];
        }
      },
      error => { console.log('Error', error); });
  }

  /**
   * metodo para elegir partidas en la interfaz de reprogramacion y consultar 
   * @param e // id_partida
   */
  getFuentesByPartidaId(e: any) {
    this.dataFuenteMeses = [];
    this.monto_total_ingresado = 0;
    if (e.value != null && e.value != '') {
      var ip = this.dataPartidas.findIndex(x => x.id === e.value);
      this.dTarea = '';
      if (ip != -1) {
        this.monto_total_partida = this.dataPartidas[ip].monto;

        //Agregado para mostrar la descripción de la tarea
        this._trs.getDescripcionTareaByTDId(this.dataPartidas[ip].tarea_detalle_id).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) { this.dTarea = result.data; }
          });
      } else {
        this.monto_total_partida = 0;
      }
      this._trs.getFuentesPartidaOById(e.value).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.dataFuenteMeses = result.data;
          } else {
            this.dataFuenteMeses = [];
          }
        },
        error => { console.log('Error', error); });
    }
  }

  calculaTotalFuente(id: number, mes: string) {
    this.monto_total_ingresado = 0;
    var i = this.dataFuenteMeses.findIndex(x => x.id === id);
    if (i != -1) {
      const total_restaA = [
        this.dataFuenteMeses[i].enero_t,
        this.dataFuenteMeses[i].febrero_t,
        this.dataFuenteMeses[i].marzo_t,
        this.dataFuenteMeses[i].abril_t,
        this.dataFuenteMeses[i].mayo_t,
        this.dataFuenteMeses[i].junio_t,
        this.dataFuenteMeses[i].julio_t,
        this.dataFuenteMeses[i].agosto_t,
        this.dataFuenteMeses[i].septiembre_t,
        this.dataFuenteMeses[i].octubre_t,
        this.dataFuenteMeses[i].noviembre_t,
        this.dataFuenteMeses[i].diciembre_t
      ].reduce((acc, val) => acc + parseFloat(val.toString().replace(',', '')), 0);

      const total_resta = parseFloat(total_restaA.toFixed(2));

      if (total_resta > this.monto_total_partida) {
        switch (mes) {
          case 'enero_t':
            this.dataFuenteMeses[i].enero_t = 0;
            break;
          case "febrero_t":
            this.dataFuenteMeses[i].febrero_t = 0;
            break;
          case "marzo_t":
            this.dataFuenteMeses[i].marzo_t = 0;
            break;
          case "abril_t":
            this.dataFuenteMeses[i].abril_t = 0;
            break;
          case "mayo_t":
            this.dataFuenteMeses[i].mayo_t = 0;
            break;
          case "junio_t":
            this.dataFuenteMeses[i].junio_t = 0;
            break;
          case "julio_t":
            this.dataFuenteMeses[i].julio_t = 0;
            break;
          case "agosto_t":
            this.dataFuenteMeses[i].agosto_t = 0;
            break;
          case "septiembre_t":
            this.dataFuenteMeses[i].septiembre_t = 0;
            break;
          case "octubre_t":
            this.dataFuenteMeses[i].octubre_t = 0;
            break;
          case "noviembre_t":
            this.dataFuenteMeses[i].noviembre_t = 0;
            break;
          default:
            this.dataFuenteMeses[i].diciembre_t = 0;
        }

        const total_restaA = [
          this.dataFuenteMeses[i].enero_t,
          this.dataFuenteMeses[i].febrero_t,
          this.dataFuenteMeses[i].marzo_t,
          this.dataFuenteMeses[i].abril_t,
          this.dataFuenteMeses[i].mayo_t,
          this.dataFuenteMeses[i].junio_t,
          this.dataFuenteMeses[i].julio_t,
          this.dataFuenteMeses[i].agosto_t,
          this.dataFuenteMeses[i].septiembre_t,
          this.dataFuenteMeses[i].octubre_t,
          this.dataFuenteMeses[i].noviembre_t,
          this.dataFuenteMeses[i].diciembre_t
        ].reduce((acc, val) => acc + parseFloat(val.toString().replace(',', '')), 0);
        const total_resta = parseFloat(total_restaA.toFixed(2));
        this.dataFuenteMeses[i].monto_t = total_resta;
        const auxFFF = this.monto_total_partida - total_resta;
        this.monto_total_ingresado = parseFloat(auxFFF.toFixed(2));

      } else {
        this.dataFuenteMeses[i].monto_t = total_resta;
        const auxFFF = this.monto_total_partida - total_resta;
        this.monto_total_ingresado = parseFloat(auxFFF.toFixed(2));

      }
    }
  }

  updateProgramacion() {
    if (this.partida_id != '') {
      var total = 0;
      for (var i = 0; i < this.dataFuenteMeses.length; i++) {
        total += parseFloat(this.dataFuenteMeses[i].monto_t);
      }
      if (total == this.monto_total_partida) {
        this._trs.putMesesTraspasoO(this.dataFuenteMeses[0]).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              var index = this.dataPartidas.findIndex(x => x.id === this.partida_id);
              if (index != -1) {
                this.dataPartidas[index].monto_procesado = total;
                this.monto_total_procesado = 0;
                for (var j = 0; j < this.dataPartidas.length; j++) {
                  this.monto_total_procesado += parseFloat(this.dataPartidas[j].monto_procesado);
                }
              }
              this.totalPartidas = this.totalPartidas + 1;
              this.dataFuenteMeses = [];
              this.partida_id = '';
              this.hasError.partida = false;
              this.refreshDataGrid();
              if (this.dataPartidas.length == this.totalPartidas)
                this.popupVisibleEdt = false;
              toastr.success('Montos por mes guardado con éxito.');

            }
          },
          error => { console.log('Error', error); });
      } else {
        toastr.warning('Ingrese los montos adecuadamente, tal que sume el TOTAL LIBERADO.');
      }
    } else {
      this.hasError.partida = true;
    }
  }

  refreshDataGrid() {
    this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
    this.dataGrid.instance.refresh();
  }

  closeModalProgramacion() {
    this.popupVisibleEdt = false;
    this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
  }

  showModalSend(id: number, total_mes: number, total_traspaso: number) {
    this.model.id = id;
    this.model.estado_id = 2;
    this.estado_traspaso = (total_traspaso - total_mes);
    this.popupVisibleSnd = true;
  }

  revisionTraspaso() {
    this._trs.putRevisionTraspasoO(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
          this.popupVisibleSnd = false;
          toastr.success('Datos enviado a revisión.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalCheck(id: number, total_mes: number, total_traspaso: number) {
    this.model.id = id;
    this.model.estado_id = 4;
    this.estado_traspaso = (total_traspaso - total_mes);
    this.popupVisibleChk = true;
  }

  aprobarTraspaso() {
    this._trs.putAprobarTraspasoO(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
          this.popupVisibleChk = false;
          toastr.success('Traspaso aprobado exitosamente.');
        }
      },
      error => { console.log('Error', error); });
  }

  calculaSaldo(fuenteId: number, id: number) {
    var i = this.dataFuentes.findIndex(x => x.fuente_id === fuenteId);
    if (i != -1) {
      var j = this.dataFuentes[i].partidas.findIndex(y => y.tarea_detalle_financiador_id === id);
      if (j != -1) {
        this.dataFuentes[i].partidas[j].sub_saldo = (parseFloat(this.dataFuentes[i].partidas[j].saldo) - parseFloat(this.dataFuentes[i].partidas[j].monto_liberado));
      }
    }
  }

  showModalDelete(id: number) {
    this.model.id = id;
    this.popupVisibleDel = true;
  }

  deleteTraspaso() {
    this._trs.deleteTraspasoOrigen(this.model.id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
          this.popupVisibleDel = false;
        }
      },
      error => { console.log('Error', error); });
  }

  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.justificacion, 'text')) {
      this.hasError.justificacion = true; res = false;
      toastr.warning('Debe registrar la justificación en la pestaña - Envío de Datos');
    }
    if (!UtilHelper.validator(data.intervencion_id, 'text')) {
      this.hasError.intervencion_id = true; res = false;
    }
    if (!UtilHelper.validator(data.operacion_id, 'text')) {
      this.hasError.operacion_id = true; res = false;
    }
    if (!UtilHelper.validator(data.tarea_id, 'text')) {
      this.hasError.tarea_id = true; res = false;
    }
    if (!UtilHelper.validator(data.tipo_traspaso_id, 'text')) {
      this.hasError.tipo_traspaso_id = true; res = false;
    }

    return res;
  }

  showModalObs(id: number) {
    this._trs.getTraspasoSeguimientoById({ id: id, tipo: 'O' }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTraspasos = result.data;
        } else {
          this.oTraspasos = [];
        }
      });
    this.popupVisibleO = true;
  }

  addCart(fuente: string, organismo: string, p: any) {
    let existeVariasFuentes: boolean = false;
    let fuenteGuardado: string;
    for (var i = 0; i < this.model2.partidas.length; i++) {
      fuenteGuardado = this.model2.partidas[i].fuente;
      if (fuenteGuardado != fuente) {
        existeVariasFuentes = true;
      }
    }

    if (existeVariasFuentes == true) {
      toastr.warning('Solo se pueden agregar partidas de la misma fuente');
    } else {

      if ((this.fuente == 'VACIO') || (this.fuente == fuente) && (this.organismo == 'VACIO') || (this.organismo == organismo)) {
        let a: any = this.model2.partidas.filter(item => item.tarea_detalle_financiador_id == p.tarea_detalle_financiador_id).map(item => item);
        if (a.length > 0) {
          for (var i = 0; i < this.model2.partidas.length; i++) {
            if (this.model2.partidas[i].tarea_detalle_financiador_id == p.tarea_detalle_financiador_id) {
              this.model2.partidas[i].monto_liberado = p.monto_liberado;
              break;
            }
          }
        }
        else {
          this.model2.partidas.push(
            {
              operacion_id: this.model.operacion_id,
              tarea_id: this.model.tarea_id,
              fuente: fuente,
              organismo: organismo,
              codigo_partida: p.codigo_partida,
              descripcion_partida: p.descripcion_partida,
              saldo: p.saldo,
              monto_liberado: p.monto_liberado,
              tarea_detalle_financiador_id: p.tarea_detalle_financiador_id,
              cantidad_liberada: p.cantidad_liberada
            }
          );
        }
        this.adicionaPartida = 1;
        this.fuente = fuente;
        this.organismo = organismo;
        this.calculaTotal();
        toastr.info('Partida adicionada correctamente, revise la pestaña "ENVÍO DE DATOS".');
      } else {
        toastr.warning('Solo se pueden agregar partidas de la misma fuente');
      }
    }
  }

  removePartida(id: number) {
    for (var i = 0; i < this.model2.partidas.length; i++) {
      if (this.model2.partidas[i].tarea_detalle_financiador_id == id) {
        this.model2.partidas.splice(i, 1);
        break;
      }
    }
  }

  calculaTotal() {
    let t = 0;
    this.model2.partidas.forEach(i => { t += parseFloat(i.monto_liberado); });
    this.total = parseFloat(t.toFixed(2));
  }

  savePartidas() {
    if (this.validCantidades()) {
      this._trs.putCantidadesPreciosByTraspaso({ data: this.dataPartidasA }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos(this.model.intervencion_id, this.model.tipo_traspaso_id);
            this.popupVisibleP = false;
            toastr.success('Operación realizada exitosamente.');
          }
        },
        error => { console.log('Error', error); });
    }
  }

  validCantidades() {
    let r = true, f1 = false, f2 = false, puf = 0, cf = 0, sf = 0, auxF = 0, put = 0, ct = 0, st = 0, auxT = 0, f3 = false;

    this.dataPartidasA.forEach(item => {
      put = parseFloat(item.precio_unitario_t);
      ct = parseFloat(item.cantidad_t);
      st = parseFloat(item.monto);
      //auxT = Math.fround(put * ct) * 100 / 100;
      var auxA = put * ct;
      auxT = (Math.floor(auxA * Math.pow(10, 2)) / Math.pow(10, 2));
      puf = parseFloat(item.precio_unitario_f);
      cf = parseFloat(item.cantidad_f);
      sf = parseFloat(item.saldo);
      //auxF = Math.fround(puf * cf) * 100 / 100;
      var auxFF = puf * cf;
      auxF = (Math.floor(auxFF * Math.pow(10, 2)) / Math.pow(10, 2));
      if ((item.cantidad_t == 0) || (item.precio_unitario_t == 0) || (item.precio_unitario_f < 0) || (item.cantidad_f < 0))
        f1 = true;
      if ((auxT > st) || (auxF > sf) || (puf * 1) > sf || (cf * 1) > sf)
        f2 = true;
      if ((sf != 0) && (auxF == 0))
        f3 = true;
    });

    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (f2) {
      r = false;
      toastr.warning('El precio unitario * el monto no debe ser mayor al saldo y monto liberado');
    }
    if (f3) {
      r = false;
      toastr.warning('La cantidad y precio unitario Formulado es diferenre al total formulado ');
    }
    return r;
  }
}
